import {useEffect, useRef, useState} from 'react';
import SelfcarePageContent from "../../../components/selfcare/SelfcarePageContent";
import {selfcareChangePayment, selfcareChangePaymentFormData, selfcareCustomer} from "../../../util/request";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import {Customer, PaymentFormData} from "../../../util/types";
import {useNavigate, useParams} from "react-router-dom";
import useAlert from "../../../util/useAlert";
import {BackButton} from "../../../components/selfcare/BackButton";
import {AlertType} from "../../../util/alert.ts";
import LoaderSpinner from '../../../components/loaders/LoaderSpinner.tsx';
import Routing from "../../../Routing.ts";

export default function ChangeCardPage() {
    const {customer} = useCustomer();

    return <SelfcarePageContent>
        <div className="selfcare-page-summary">
            <h1 className="heading heading--big">Skift Betalingskort</h1>
            <p>Husk at vende tilbage til denne side, når du har godkendt med MitID.</p>
            <p>
                Kan du ikke opdatere dit kort?<br/>
                Tjek <a href={'https://www.nets.eu/dk-da/Pages/driftstatus.aspx'} target={'_blank'} rel={'nofollow'}>Nets driftstatus</a> eller kontakt din bank.
            </p>
        </div>
        <BackButton default_url={Routing.Selfcare.Card}/>
        <PaymentForm customer={customer}/>
    </SelfcarePageContent>
}

export function ChangeCardSuccessPage() {
    const {setCustomer} = useCustomer()
    const navigate = useNavigate()
    const {setAlert} = useAlert()
    const { customer_id = '', quickpay_order_id = '' } = useParams()

    useEffect(() => {
        selfcareChangePayment(customer_id, quickpay_order_id)
            .then(() => {
                selfcareCustomer(customer_id).then((r) => {
                    setCustomer(r.response.data)
                    setAlert(AlertType.success, "Kortet er skiftet.\nHar du en ubetalt regning, forsøger vi automatisk at trække pengene nu.")
                })
                .then(() => navigate(Routing.Selfcare.Card))
                .catch(() => {
                    setAlert(AlertType.error, 'Noget gik galt!')
                    navigate(Routing.Selfcare.Card)
                })
            })
            .catch(() => {
                setAlert(AlertType.error, 'Noget gik galt!')
                navigate(Routing.Selfcare.Card)
            })
    }, [customer_id,  navigate, quickpay_order_id, setAlert, setCustomer])

    return <LoaderSpinner/>
}

export function ChangeCardErrorPage() {
    const navigate = useNavigate()
    const {setAlert} = useAlert()

    setAlert(AlertType.error, 'Noget gik galt!')
    navigate(Routing.Selfcare.Card)

    return <LoaderSpinner/>
}


function PaymentForm({customer: { customer_id }} : {customer: Customer}) {
    const [loading, setLoading] = useState<boolean>(false);
    const [paymentFormData, setPaymentFormData] = useState<PaymentFormData | null>(null);
    const formRef = useRef<HTMLFormElement | null>(null);

    useEffect(() => {
        setLoading(true)
        selfcareChangePaymentFormData(customer_id)
            .then(r => {
                setPaymentFormData(r.response.data)
            }).finally(() => setLoading(false))
    }, [customer_id])

    useEffect(() => {
        formRef.current?.submit();
    }, [paymentFormData]);

    if (loading) {
        return <LoaderSpinner/>
    }

    if (paymentFormData === null) return <p>Error</p>;

    return <>
        <iframe id="creditcard-iframe" title="frame" name="creditcard-iframe" width="100%"></iframe>
        <form ref={formRef} id="creditcard-form-for-iframe" method="POST" action={paymentFormData.quickpay_post_action} target="creditcard-iframe">
            {Object.entries(paymentFormData).map(([key, value]) => <input key={key} type="hidden" name={key} value={value} />)}
        </form>
    </>
}
